// Single source of truth for what BlendSafe Pro offers. Each feature flips
// `live: true` only once it's actually built and backed by real content — the
// /pro and /pricing pages render ONLY live features, so we never promise or
// show "coming soon" for something that doesn't exist yet.
export const PRO_FEATURES = [
  {
    key: "routine",
    title: "Routine Checker",
    blurb: "Check your whole routine against your medications in one pass.",
    live: true,
  },
  {
    key: "report",
    title: "Discussion Report",
    blurb: "A PDF for your prescriber — every finding linked to its source.",
    live: true,
  },
  {
    key: "swaps",
    title: "What to use instead",
    blurb: "Safer products, each reviewed against your medication.",
    live: true,
  },
  {
    key: "alerts",
    title: "Change alerts",
    blurb: "We email you if a result you saved changes.",
    live: true,
  },
  {
    key: "tracker",
    title: "Course tracker",
    blurb: "Week-by-week notes for your medication, with weekly reminders.",
    live: true,
  },
  {
    key: "recheck",
    title: "Prescription-change re-check",
    blurb: "Re-run every saved routine when your medications change.",
    live: true,
  },
  {
    key: "digest",
    title: "Monthly digest",
    blurb: "What changed for your routines each month — only when there's news.",
    live: true,
  },
  {
    key: "profiles",
    title: "Multiple profiles",
    blurb: "One account for your whole household — unlimited profiles.",
    live: true,
  },
  {
    key: "share",
    title: "Share with your derm",
    blurb: "Email your report straight to your clinic from hello@blendsafe.com.",
    live: true,
  },
];

export const LIVE_PRO_FEATURES = PRO_FEATURES.filter((f) => f.live);
